import React, { useEffect, useRef, useState } from 'react';
import { Loader } from '../../../../../../Common';
import { Button, Card, CardBody, CardHeader, Col, Container, Row, UncontrolledTooltip } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import SearchSelectList from '../Comman/SearchSelectedList';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { adminAPIURL } from '../../../../../../Config';
import { RxCross2 } from 'react-icons/rx';
import zoneV1 from '../../../../../../../assets/images/zone-v2.svg';
import airplane from '../../../../../../../assets/images/airplane.svg';
import vendorClient from '../../../../../../../assets/images/vendor-client.svg';
import { isValidEmail } from '../../../../../../Helpers/Helpers';
import AddVendor from './Components/AddVendor';
import { ChevronLeft } from 'react-feather';
import cogoToast from 'cogo-toast';
import PartialVendorConfigure from '../Comman/Modal/PartialVendorConfigure';
import { SAVE_DRAFT_CONFIGURATION, UPDATE_DRAFT_CONFIGURATION } from '../../../../../../../store/actions';
import TypeCard from '../Comman/TypeCard';
// import AddZone from './Components/AddZone';

// import AddAirport from './Components/AddAirport';

const initialState = {
  id: '',
  name: '',
  email: '',
  documentUrl: '',
  region: null,
  currency: null,
  selectedCarTypes: [],
};

const SelectVendor = ({ state, setState, setFormCount, isDraftConfiguration, configuration }) => {
  const dispatch = useDispatch();

  const history = useHistory();
  const [vendor, setVendor] = useState(initialState);
  const [selectedVendors, setSelectedVendors] = useState<any>([]);
  const [selectedAirports, setSelectedAirports] = useState<any>([]);
  const [add, setAdd] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef(null);
  const timeoutRef = useRef(null);
  const [errors, setErrors] = useState<any>({});
  const [isPartiallyVendorConfigureOpenModal, setIsPartiallyVendorConfigureOpenModal] = useState(false);
  const [isVendorFullConfigure, setIsVendorFullConfigure] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const [car, setCar] = useState([
    {
      carName: '',
      carType: null,
    },
  ]);

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setShowPopup(true);
  };
  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShowPopup(false);
    }, 100); // small delay to allow cursor to enter popup
  };

  useEffect(() => {
    setSelectedAirports(state?.vendorPricing?.airports ?? []);
    setSelectedVendors(state?.vendorPricing?.vendors ?? []);
  }, []);

  const validate = () => {
    const newErrors: any = {};
    if (!vendor.name.trim()) newErrors.name = 'Vendor Name is required';
    if (isVendorFullConfigure && !vendor.documentUrl) {
      newErrors.documentUrl = 'Document is required';
    }
    if (!vendor.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!isValidEmail(vendor.email.trim())) {
      newErrors.email = 'Invalid email format';
    }

    if (!vendor.region) newErrors.region = 'Region is required';
    if (!vendor.currency) newErrors.currency = 'Currency is required';
    if (vendor.selectedCarTypes.length === 0) newErrors.selectedCarTypes = 'Please select at least one car type';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  const saveAsDraftHandler = () => {
    if (!validateVendors(selectedVendors)) return;

    setState(prev => ({ ...prev, vendorPricing: { ...prev?.vendorPricing, vendors: selectedVendors } }));

    dispatch({
      type: SAVE_DRAFT_CONFIGURATION,
      payload: {
        data: {
          configuration_data: {
            client: state?.client,
            project: state?.project,
            benefit: state?.benefit,
            benefitGroup: state?.benefitGroup,
            vendorPricing: {
              ...state?.vendorPricing,
              vendors: selectedVendors,
            },
            page: 8,
          },
          configuration_type: 'program_onboarding',
          status: 'DRAFT',
        },
      },
    });
  };

  const updateAsDraftHandler = () => {
    if (!validateVendors(selectedVendors)) return;

    setState(prev => ({ ...prev, vendorPricing: { ...prev?.vendorPricing, vendors: selectedVendors } }));

    dispatch({
      type: UPDATE_DRAFT_CONFIGURATION,
      payload: {
        data: {
          configuration_data: {
            client: state?.client,
            project: state?.project,
            benefit: state?.benefit,
            benefitGroup: state?.benefitGroup,
            vendorPricing: {
              ...state?.vendorPricing,
              vendors: selectedVendors,
            },
            page: 8,
          },
          configuration_type: 'program_onboarding',
          status: 'DRAFT',
          id: configuration?.id,
        },
      },
    });
  };

  const handleSubmit = () => {
    if (!validateVendors(selectedVendors)) return;

    setState(prev => ({ ...prev, vendorPricing: { ...prev?.vendorPricing, vendors: selectedVendors } }));
    setFormCount((prev: number) => prev + 1);
  };

  const validateVendors = (vendors: any[]): boolean => {
    if (!vendors || vendors.length === 0) {
      cogoToast.error('Please select at least one vendor.');
      return false;
    }

    const vendorsMissingCarTypes = vendors.filter(vendor => !vendor.carTypes || vendor.carTypes.length === 0);

    if (vendorsMissingCarTypes.length > 0) {
      const names = vendorsMissingCarTypes.map(v => v.name || 'Unnamed').join(', ');
      cogoToast.error(`Each vendor must have at least one car type. Missing for: ${names}`);
      return false;
    }

    return true;
  };

  const handleCreateVendor = () => {
    if (validate()) {
      if (!isVendorFullConfigure) setIsPartiallyVendorConfigureOpenModal(true);
      else {
        createVendor();
      }
    }
  };

  const handleUpdateVendor = () => {
    if (validate()) {
      setAdd(false);
      setSelectedVendors(prev => {
        const vendorIndex = prev.findIndex(v => v.id === vendor?.id);

        const newVendor = {
          id: vendor?.id,
          firstName: vendor?.name?.split(' ')?.[0] || '',
          lastName: vendor?.name?.split(' ')?.[1] || '',
          email: vendor?.email,
          documentUrl: vendor?.documentUrl,
          region: vendor?.region?.label,
          currency: vendor?.currency?.value,
          carTypes:
            vendor?.selectedCarTypes?.map(carType => {
              const getCarsForCarType = car
                .filter(carItem => carType?.id === carItem?.carType?.value)
                ?.map(carItem => ({
                  carName: carItem?.carName,
                  tag: 'partially_configured',
                }));
              console.log('car check', car);
              return {
                ...carType,
                cars: getCarsForCarType,
              };
            }) ?? [],
          tag: 'partially_configured',
        };

        if (vendorIndex !== -1) {
          // Replace existing vendor
          const updated = [...prev];
          updated[vendorIndex] = newVendor;
          return updated;
        }
        // Otherwise add new vendor
        return [...prev, newVendor];
      });
      setVendor(initialState);
      setIsVendorFullConfigure(false);
      setIsPartiallyVendorConfigureOpenModal(false);
      setCar([
        {
          carName: '',
          carType: null,
        },
      ]);
      setIsUpdate(false);
    }
  };

  const createVendor = () => {
    setAdd(false);
    setSelectedVendors(prev => [
      ...prev,
      {
        id: Math.random().toString(36).substring(2, 10),
        firstName: vendor?.name?.split(' ')?.[0] || '',
        lastName: vendor?.name?.split(' ')?.[1] || '',
        email: vendor?.email,
        documentUrl: vendor?.documentUrl,
        region: vendor?.region?.label,
        currency: vendor?.currency?.value,
        carTypes: vendor?.selectedCarTypes.map(carType => {
          const getCarsForCarType = car
            .filter(carItem => carType?.id === carItem?.carType?.value)
            ?.map(carItem => ({
              carName: carItem?.carName,
              tag: 'partially_configured',
            }));
          return {
            ...carType,
            cars: getCarsForCarType,
          };
        }),
        tag: 'partially_configured',
      },
    ]);
    setVendor(initialState);
    setIsVendorFullConfigure(false);
    setIsPartiallyVendorConfigureOpenModal(false);
    setCar([
      {
        carName: '',
        carType: null,
      },
    ]);
  };

  const countZones =
    selectedAirports?.reduce((acc, curr) => {
      acc += curr?.zones?.length;
      return acc;
    }, 0) ?? 0;

  const handleCarType = (removeCarType, vendorIndex) => {
    setSelectedVendors(prev =>
      prev.map((vendor, index) =>
        index === vendorIndex
          ? {
              ...vendor,
              carTypes: vendor.carTypes?.filter(ct => ct.id !== removeCarType.id),
            }
          : vendor,
      ),
    );
  };

  const handleRemoveVendor = indexToRemove => {
    setSelectedVendors(prev => prev.filter((_, i) => i !== indexToRemove));
  };

  const handleSelect = selectedItem => {
    setSelectedVendors(selectedItem);
  };

  return (
    <div className="page-content">
      {isPartiallyVendorConfigureOpenModal && (
        <PartialVendorConfigure
          onClose={() => {
            setIsPartiallyVendorConfigureOpenModal(false);
          }}
          handleYes={createVendor}
          handleNo={() => {
            setIsVendorFullConfigure(true);
            setIsPartiallyVendorConfigureOpenModal(false);
          }}
        />
      )}

      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1 align-items-center">
            <BreadcrumbTrail
              title={`Airport Configuration Setup`}
              navigationby={breadcrumNavigationHandler}
              navigation={['Management', 'Program', 'Onboarding', 'Select Vendor']}
            />
          </div>
        </div>

        <Card>
          <CardHeader className="d-flex justify-content-between p-0">
            <h5 className="m-0 fw-semibold px-3">Add vendors to the selected zone</h5>
            <TypeCard typeName={'Client'} name={state?.client?.name} />
          </CardHeader>
          <CardBody>
            <Row className="mb-3">
              {/* Search Airports */}
              <Col md="8">
                <SearchSelectList
                  label="Search Vendors"
                  subLabel="Search and select vendors to manage"
                  placeholder="Type vendor name..."
                  selectedItems={selectedVendors}
                  onSelect={handleSelect}
                  searchApi={async query => {
                    const res = await axios({
                      method: 'GET',
                      url: `${adminAPIURL}/v2/vendor/benefit-type/airport-transfer`,
                      headers: {
                        'Project-Code': `ADMIN_ACCESS`,
                      },
                      params: {
                        search: query, // Changed `name` to `searchName`
                        // draft: true,
                      },
                      withCredentials: true,
                    });
                    return res?.data?.vendors;
                  }}
                  renderItem={item => (
                    <div className="d-flex gap-2 align-items-center">
                      <img src={vendorClient} alt="" />
                      {item.firstName || ''} {item.lastName || ''}
                    </div>
                  )}
                  name="vendor"
                  setAdd={setAdd}
                />
              </Col>

              {/* Selected Airports */}
              <Col md="4">
                <Card className="border rounded-3 mt-3 mb-3 d-flex flex-column" style={{ height: '250px' }}>
                  <h6 className="fw-semibold mx-3 mt-3">Selected Vendors</h6>
                  <p className="text-muted mb-2 small mx-3">Currently selected vendors ({selectedVendors?.length})</p>

                  <div className="mt-1 airport-list mx-3 flex-grow-1 ">
                    {selectedVendors.map((vendor, vendorIndex) => {
                      return (
                        <div
                          key={vendor.id}
                          style={{
                            background: '#EAEDF5',
                            borderRadius: '5px',
                          }}
                          className={`mb-2 p-1 ps-3 px-3`}
                        >
                          <div className="d-flex align-items-start justify-content-between">
                            <div className="d-flex gap-2 align-items-start">
                              <img src={vendorClient} alt="" />
                              <div>
                                <p className="m-0 fs-12">
                                  {vendor?.name || ''} {vendor.firstName || ''} {vendor.lastName || ''}
                                </p>
                                <div className="d-flex gap-1 flex-wrap mt-1">
                                  {vendor?.carTypes?.map(car => {
                                    return (
                                      <div key={car.id} className="d-flex gap-2 align-items-center zone-list ps-2 px-2">
                                        <p className="m-0 fs-10">{car?.name?.split(' ')[0]}</p>
                                        <i className="ri-close-line cursor-pointer" onClick={() => handleCarType(car, vendorIndex)}></i>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                            <div className="d-flex gap-1">
                              {/* {vendor?.tag === 'partially_configured' && (
                                <i className="ri-edit-line cursor-pointer" onClick={() => handleUpdateMode(vendor)}></i>
                              )} */}
                              <i className="ri-close-line cursor-pointer" onClick={() => handleRemoveVendor(vendorIndex)}></i>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="d-flex align-items-center justify-content-around rounded-bottom pt-1 pb-1" style={{ background: '#D5DAEC' }}>
                    <div className="d-flex align-items-center gap-1">
                      <img src={airplane} alt="" color="blue" />
                      <p className="m-0">Airport - {selectedAirports?.length}</p>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <img src={zoneV1} alt="" color="blue" />
                      <p className="m-0">Zone - {countZones}</p>
                    </div>
                    <p
                      id="viewTooltip"
                      className="m-0 text-decoration-underline fw-medium cursor-pointer"
                      style={{ color: '#405189' }}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      View
                    </p>
                  </div>

                  {showPopup && (
                    <Card
                      ref={popupRef}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      className="position-absolute shadow bg-white border rounded p-2"
                      style={{
                        zIndex: 9999,
                        top: '100%', // position below the "View" text
                        right: 0,
                        width: '100%',
                      }}
                    >
                      <p className="p-s2 pt-2 m-0">Details Picked</p>
                      <hr className="mt-2 mb-2" />

                      <p className="m-0 fs-12 mb-1" style={{ color: '#ABB9E8' }}>
                        Airport
                      </p>

                      {selectedAirports?.map((airport, index) => (
                        <p className="mb-1">
                          <span> {index + 1}.</span>
                          &nbsp;
                          <span className="fs-12">{airport?.name}</span>
                        </p>
                      ))}

                      <p className="m-0 fs-12 mb-1" style={{ color: '#ABB9E8' }}>
                        Zone Type
                      </p>

                      <div className="d-flex flex-wrap gap-2 mt-2">
                        {selectedAirports?.map(airport => {
                          const zones = airport?.zones;
                          return zones?.map(zone => (
                            <p
                              className="pt-1 pb-1 ps-3 px-3 fs-12 m-0"
                              key={zone?.id}
                              style={{
                                border: '1px solid #ABB9E8',
                                borderRadius: '15px',
                                color: '#405189',
                                maxWidth: '100px',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {zone?.name?.split(' ')?.[0]}
                            </p>
                          ));
                        })}
                      </div>
                    </Card>
                  )}
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {add && (
          <Card className="p-3">
            <CardHeader tag="h5" className="border-bottom pb-2">
              Add Vendor
            </CardHeader>

            <CardBody>
              <AddVendor
                vendor={vendor}
                setVendor={setVendor}
                errors={errors}
                setErrors={setErrors}
                state={state}
                isVendorFullConfigure={isVendorFullConfigure}
                car={car}
                setCar={setCar}
                isUpdate={isUpdate}
              />
              <div className="d-flex justify-content-between mt-4">
                <Button
                  className="btn btn-primary btn-light"
                  onClick={() => {
                    setAdd(false);
                    setVendor(initialState);
                    setIsVendorFullConfigure(false);
                    setIsUpdate(false);
                  }}
                >
                  Cancel
                </Button>
                <Button color="success" onClick={isUpdate ? handleUpdateVendor : handleCreateVendor}>
                  {isUpdate ? 'Update Vendor' : 'Add Vendor'}
                </Button>
              </div>
            </CardBody>
          </Card>
        )}

        <div className="d-flex justify-content-between">
          <Button
            onClick={() => setFormCount((prev: number) => prev - 1)}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{
              backgroundColor: '#E9EBEC', // light gray
              color: '#404B7C', // navy/dark blue
              fontWeight: 500,
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <ChevronLeft size={18} />
            Back
          </Button>
          <div className="d-flex gap-2">
            {isDraftConfiguration && (
              <Button className="btn btn-success" style={{ width: '150px' }} color="primary" onClick={updateAsDraftHandler}>
                Update As Draft
              </Button>
            )}

            {!isDraftConfiguration && (
              <Button className="btn btn-success" style={{ width: '130px' }} color="primary" onClick={saveAsDraftHandler}>
                Save As Draft
              </Button>
            )}

            <Button className="overlay-disable " style={{ width: '250px' }} color="primary" onClick={handleSubmit}>
              Manage Vendor with Zone
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SelectVendor;
